<template>
  <div class="SplitScreenContrast">
    <div class="split-container ah" v-if="showSplitScreenContrast">
      <div class="header">
        <div>
          <el-select
            v-model="area"
            class="select"
            placeholder="请选择"
            @change="loadAreaModel(true)"
          >
            <el-option
              v-for="item in areas1"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </div>
        <div>
          <el-select
            v-model="area2"
            class="select"
            placeholder="请选择"
            @change="loadAreaModel2(true)"
          >
            <el-option
              v-for="item in areas2"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </div>
        <el-button type="danger" class="exit" @click="exit">退出</el-button>
      </div>
      <div class="split">
        <app-cesium-viewer ref="viewer" @loaded="loaded"></app-cesium-viewer>
        <app-cesium-viewer ref="viewer2" @loaded="loaded2"></app-cesium-viewer>
      </div>
      <div class="split-line"></div>
    </div>
  </div>
</template>
<script>
import AppCesiumViewer from '@/components/app-cesium-viewer.vue'
import { mapGetters } from 'vuex'
import * as api2 from '@/api/area.js'
import * as api3 from '@/api/marker'
import { treeForeach } from '@/utils/tree'

export default {
  components: {
    AppCesiumViewer
  },
  data () {
    return {
      areas: [],
      area: undefined,
      area2: undefined,
      area2copy: undefined
    }
  },
  inject: ['refresh'],
  computed: {
    ...mapGetters(['showSplitScreenContrast', 'modelHeight']),
    areas1 () {
      return this.areas.filter((p) => !this.area2 || p.id !== this.area2)
    },
    areas2 () {
      return this.areas.filter((p) => !this.area || p.id !== this.area)
    }
  },
  methods: {
    exit () {
      this.viewer = this.viewer2 = undefined
      if (this.showSplitScreenContrast) {
        this.$store.commit('SELECT_SPLITSCREENCONTRAST', false)
        // 强制刷新当前路由
        this.refresh()
      }
    },
    /**
     * 加载完毕事件
     */
    async loaded (viewer) {
      if (this.viewer2) this.viewer2.scene.camera = viewer.scene.camera
      this.viewer = viewer
      await this.$nextTick()
    },
    /**
     * 加载完毕事件
     */
    async loaded2 (viewer) {
      if (this.viewer) this.viewer.scene.camera = viewer.scene.camera
      this.viewer2 = viewer
      if (!this.$route.query.areaId) {
        console.log('地图未设置区域信息')
        return
      }
      this.area2copy = this.area2 = Number(this.$route.query.areaId)
      await this.$nextTick()
      this.loadAreaModel2(true)
    },
    async loadAreaModel (flyTo) {
      this._tileset && this._tileset()
      this._tileset = await this.load3DTileset(this.area, (tilesets) => {
        tilesets.forEach((tileset) => {
          this.viewer.scene.primitives.add(tileset)
        })
        flyTo && this.viewer.flyTo(tilesets[0])
      })
    },
    async loadAreaModel2 (flyTo) {
      this._tileset2 && this._tileset2()
      this._tileset2 = await this.load3DTileset(this.area2, (tilesets) => {
        tilesets.forEach((tileset) => {
          this.viewer2.scene.primitives.add(tileset)
        })
        flyTo && this.viewer2.flyTo(tilesets[0])
      })
    },
    /**
     * 返回一个可销毁的对象
     */
    async load3DTileset (areaId, fn) {
      const { data } = await api3.getMapModel({ id: areaId })
      const temp = [data]
      treeForeach(data.children || [], 'children', (item) => temp.push(item))
      const tilesetDatas = temp
        .map((p) => p.model)
        .filter((p) => p && p.link)
      const tilesets = []
      for (let i = 0; i < tilesetDatas.length; i++) {
        let { height } = tilesetDatas[i]
        const url = tilesetDatas[i].link
        if (areaId === this.area2copy) {
          height += this.modelHeight || 0
        }
        const tileset = await Cesium.Cesium3DTileset.fromUrl(url)
        const boundingSphere = tileset.boundingSphere
        const cartographic = Cesium.Cartographic.fromCartesian(
          boundingSphere.center
        )
        const surface = Cesium.Cartesian3.fromRadians(
          cartographic.longitude,
          cartographic.latitude,
          cartographic.height
        )
        const offset = Cesium.Cartesian3.fromRadians(
          cartographic.longitude,
          cartographic.latitude,
          height || 0
        )
        const translation = Cesium.Cartesian3.subtract(
          offset,
          surface,
          new Cesium.Cartesian3()
        )
        tileset.modelMatrix = Cesium.Matrix4.fromTranslation(translation)
        tilesets.push(tileset)
      }
      fn && fn(tilesets)

      return () => {
        tilesets.forEach((tileset) => {
          tileset.destroy()
        })
      }
    }
  },
  async mounted () {
    const { data } = await api2.getArealList()
    const temp = []
    data.forEach((d) => {
      temp.push(d)
      treeForeach(d.children || [], 'children', (item) => temp.push(item))
    })
    // if (temp.length > 0) { this.area = temp[0].id }
    this.areas = temp
  },
  destroyed () {
    this.exit()
  }
}
</script>

<style lang="scss" scoped>
.SplitScreenContrast {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  z-index: 1001;
  pointer-events: none;
  .split-container {
    pointer-events: all;
    position: relative;
    .header {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 50px;
      top: 0px;
      display: flex;
      align-items: center;
      background-color: rgba(0, 0, 0, 0.85);
      > * {
        flex: 1;
      }
    }
    .split {
      // height: calc(100% - 50px);
      height: 100%;
      display: flex;
      > * {
        flex: 1;
      }
    }
  }
  .split-line {
    position: absolute;
    margin: 0 auto;
    width: 2px;
    left: calc(50% - 1px);
    top: 0px;
    height: 100%;
    background-color: #bbb;
    z-index: 2;
  }
  .select {
    width: 400px;
    height: 32px;
    // background: rgba(255, 255, 255, 0.1);
    // border-radius: 6px;
  }
  .exit {
    position: absolute;
    right: 20px;
    width: 40px;
    height: 24px;
    padding: 0px !important;
    background-color: #f54949 !important;
    // &:hover {
    //   border-color: transparent !important;
    //   filter: brightness(1.1);
    // }
  }
}
</style>
